import { getDateRange } from '@modules/common/components/DateRangePicker/helpers';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import invariant from 'tiny-invariant';
import { AggregatePeriod } from 'v2/core/entities';

interface GetAggregatePeriodForLowerBucketCountLimitParams {
  currentAggregatePeriod: AggregatePeriod;
  dateRange: DateTimeRange;
  upperBucketCountLimit: {
    weekly: number;
    daily: number;
  };
}

export const getAggregatePeriodForUpperBucketCountLimit = ({
  currentAggregatePeriod,
  dateRange,
  upperBucketCountLimit: {
    weekly: upperWeeklyBucketCountLimit,
    daily: upperDailyBucketCountLimit,
  },
}: GetAggregatePeriodForLowerBucketCountLimitParams) => {
  if (currentAggregatePeriod === AggregatePeriod.MONTH) {
    return currentAggregatePeriod;
  }

  const [startDate, endDate] = getDateRange(dateRange);
  invariant(!!startDate, "startDate can't be null");
  invariant(!!endDate, "endDate can't be null");

  const isWeeklyBucketCountExceedingLimit =
    endDate.diff(startDate, 'week') > upperWeeklyBucketCountLimit;

  if (isWeeklyBucketCountExceedingLimit) {
    return AggregatePeriod.MONTH;
  }

  const isDailyBucketCountExceedingLimit =
    endDate.diff(startDate, 'day') > upperDailyBucketCountLimit;

  if (
    currentAggregatePeriod === AggregatePeriod.DAY &&
    isDailyBucketCountExceedingLimit
  ) {
    return AggregatePeriod.WEEK;
  }

  return currentAggregatePeriod;
};
